import { axios, createFormData, handleError } from '../axios';

export const getComment = (data) => {
  return new Promise((resolve) => {
    axios
      .post('post/comment/more', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
